import $foreign from "./foreign.cjs";
var fromStringImpl = $foreign.fromStringImpl;
var infinity = $foreign.infinity;
var $$isFinite = $foreign.isFinite;
var $$isNaN = $foreign.isNaN;
var nan = $foreign.nan;
export { fromStringImpl, infinity, $$isFinite as isFinite, $$isNaN as isNaN, nan };
